<div class="slides-container">
  <div cdkDropList cdkDropListOrientation="horizontal" class="slides-list" (cdkDropListDropped)="onSlideDrop($event)">
    @for (slide of slides; track trackBySlideId($index, slide)) {
      <div
        cdkDrag
        cdkDragPreviewClass="slide-drag-preview"
        class="slide-item"
        [class.active]="isCurrentSlide(slide.uuid)"
        (click)="onSlideClick(slide.uuid)"
      >
        <div
          [attr.data-slide-uuid]="slide.uuid"
          [style.background-color]="slide.background_color"
          [style.background-image]="slide.background_image"
          [style.background-size]="'cover'"
          [style.background-position]="'center'"
          [style.background-repeat]="'no-repeat'"
          class="slide-thumbnail"
          cdkDragHandle
          [ngStyle]="getAspectRatioStyle()"
          [matTooltip]="slide.name"
        >
          <div class="thumbnail-live-preview">
            <gb-presenter-canvas
              [backgroundColor]="slide.background_color"
              [backgroundImage]="slide.background_image?.image || null"
              [backgroundImageCover]="slide.background_image_cover"
              [customCss]="slide.custom_css"
              [draggable]="false"
              [responsive]="true"
              [inPreviewMode]="true"
              [previewSlideUuid]="slide.uuid"
            ></gb-presenter-canvas>
          </div>
        </div>
        <div class="slide-actions">
          <div class="action-button-container">
            <button
              class="action-button"
              [matMenuTriggerFor]="slideMenu"
              #menuTrigger="matMenuTrigger"
              (click)="$event.stopPropagation()"
              [matTooltip]="'PRESENTER.SLIDES.MORE_OPTIONS' | translate"
            >
              <gb-icon height="20px" icon="ellipsis-horizontal"></gb-icon>
            </button>
          </div>
          <mat-menu #slideMenu="matMenu">
            <button mat-menu-item (click)="onDuplicateSlide(slide.uuid, $event)">
              <mat-icon>content_copy</mat-icon>
              <span>{{ 'PRESENTER.SLIDES.DUPLICATE' | translate }}</span>
            </button>
            <button mat-menu-item (click)="onRenameSlide(slide.uuid, $event, menuTrigger)">
              <mat-icon>edit</mat-icon>
              <span>{{ 'PRESENTER.SLIDES.RENAME' | translate }}</span>
            </button>
            <button mat-menu-item (click)="onDeleteSlide(slide.uuid, $event)" [disabled]="slides && slides.length <= 1">
              <mat-icon>delete</mat-icon>
              <span>{{ 'DELETE' | translate }}</span>
            </button>
          </mat-menu>
        </div>
        <div class="slide-drop-placeholder" *cdkDragPlaceholder [ngStyle]="getAspectRatioStyle()"></div>
      </div>
    }
  </div>

  <div class="add-slide-container">
    <button
      mat-stroked-button
      class="add-slide-button"
      (click)="onAddSlide()"
      [matTooltip]="'PRESENTER.SLIDES.ADD_SLIDE_TOOLTIP' | translate"
    >
      <gb-icon icon="add"></gb-icon>
    </button>
  </div>
</div>
